import axios from "../../utils/axios";

export const getPosts = async (sort, isSaved) => {
    let query_string = '';
    if (sort !== '') {
        query_string += sort == 'newest' ? '_sort=createdAt&_order=desc' : '_sort=likes&_order=desc'
    }

    if (isSaved == true) {
        query_string += query_string !== '' ? '&isSaved=true' : 'isSaved=true'
    }

    const response = await axios.get(`/blogs?${query_string}`);

    return response.data;
};
